import { useContext } from 'react';
import NotificationStateContext from '../../wedding-wardrobe/src/components/base/NotificationStateContext';

export default () => useContext(NotificationStateContext);
